import { computed, observable } from "mobx";
import { Type } from "class-transformer";
import VehicleRegisterVehicleCategory from "./vehicleRegisterVehicleCategory";
import VehicleRegisterVehicleClassifiedFuelType from "./vehicleRegisterVehicleClassifiedFuelType";
import VehicleRegisterVehiclePermittedActionsResponse from "./vehicleRegisterVehiclePermittedActionsResponse";
import VehicleRegisterVehicleStatus from "./vehicleRegisterVehicleStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class VehicleRegisterVehicleResponse {
  /**
   * Vehicle ID.
   */
  @observable
  vehicleId!: string;

  /**
   * License plate.
   */
  @observable
  licensePlate!: string;

  /**
   * CountryId for vehicle.
   */
  @observable
  countryId!: string;

  /**
   * Date and time of the last modification of the vehicle.
   */
  @observable
  @Type(() => Date)
  updatedAt!: Date;

  /**
   * VIN (vehicle identification number) - an internationally unique identifier for motor vehicles.
   */
  @observable
  vin?: string;

  /**
   * Date on which the vehicle has been assigned its license plate.
   */
  @observable
  @Type(() => Date)
  licensePlateValidSinceDate?: Date;

  /**
   * Date until which the vehicle has been assigned its license plate.
   */
  @observable
  @Type(() => Date)
  licensePlateValidUntilDate?: Date;

  @observable
  vehicleStatus?: VehicleRegisterVehicleStatus;

  /**
   * Date from which the vehicle has the specified status.
   */
  @observable
  @Type(() => Date)
  vehicleStatusValidSinceDate?: Date;

  /**
   * Date until which the vehicle has the specified status.
   */
  @observable
  @Type(() => Date)
  vehicleStatusValidUntilDate?: Date;

  @observable
  category?: VehicleRegisterVehicleCategory;

  /**
   * Maximum allowed weight.
   */
  @observable
  maximumAllowedWeight?: number;

  @observable
  classifiedFuelType?: VehicleRegisterVehicleClassifiedFuelType;

  @observable
  @Type(() => VehicleRegisterVehiclePermittedActionsResponse)
  permittedActions!: VehicleRegisterVehiclePermittedActionsResponse;
}

export default class VehicleRegisterVehicle extends VehicleRegisterVehicleResponse {
  @computed
  get searchId() {
    return this.vehicleId;
  }
}
